import { useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import { selectedPointDetail, selectedSubImageState } from 'store/buildingStore'
import Krpano from 'utils/krpano'
import { KrpanoEngine } from 'utils/KrpanoEngine'

export default function useResetToInitView() {
  const pointDetail = useRecoilValue(selectedPointDetail)
  const selectedSubImage = useRecoilValue(selectedSubImageState)

  useEffect(() => {
    const handleReset = () => {
      const krpano =
        new KrpanoEngine('preview').instance ||
        new KrpanoEngine('full').instance
      if (!krpano || !pointDetail) return

      const selectedImageData = selectedSubImage
        ? pointDetail.subImages?.find((img) => img.id === selectedSubImage)
        : null

      const targetH = Krpano.NormalizeAngle(
        selectedImageData?.initView?.h ?? pointDetail.initView?.h ?? 0
      )
      const targetV =
        selectedImageData?.initView?.v ?? pointDetail.initView?.v ?? 0
      const targetZ =
        selectedImageData?.initView?.z ?? pointDetail.initView?.z ?? 100

      krpano.call(`lookto(${targetH}, ${targetV}, ${targetZ}, smooth())`)
    }

    ;(window as any).reset_to_init_view = handleReset

    return () => {
      delete (window as any).reset_to_init_view
    }
  }, [pointDetail, selectedSubImage])
}
